import React from "react";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import { useSharedSelector } from "../../store/SharedProvider";
import { selectIsReadOnly } from "../../store/app-configurations/app-configurations-selectors";

const ReadOnlyProtectedIconButton = React.forwardRef((props: IconButtonProps, ref: any) => {
  const isReadOnly = useSharedSelector((state) => selectIsReadOnly(state));

  return <IconButton {...props} ref={ref} disabled={props.disabled || isReadOnly} />;
});

export default ReadOnlyProtectedIconButton;
